import { render, staticRenderFns } from "./SelectedProductPanel.vue?vue&type=template&id=5c6af89f&scoped=true&"
import script from "./SelectedProductPanel.vue?vue&type=script&lang=js&"
export * from "./SelectedProductPanel.vue?vue&type=script&lang=js&"
import style0 from "./SelectedProductPanel.vue?vue&type=style&index=0&id=5c6af89f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c6af89f",
  null
  
)

export default component.exports